import { Grid } from '@mui/material';

import { NameTextField } from './NameTextField';
import { EMailTextField } from './EMailTextField';
import { DetailsTextField } from './DetailsTextField';
import { SendButton } from './SendButton';

export const ContactForm = () => {
    return (
        <Grid data-testid="contact-form" container direction="column" p={1} spacing={2}>
            <Grid item>
                <NameTextField />
            </Grid>
            <Grid item>
                <EMailTextField />
            </Grid>
            <Grid item>
                <DetailsTextField />
            </Grid>
            <Grid item>
                <Grid container direction="row">
                    <SendButton />
                </Grid>
            </Grid>
        </Grid>
    )
}
